import _ from "lodash";
import { defineStore } from "pinia";

import { getHotelOrders } from "@/api/biz/openHotel";
import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { store } from "@/store";
import { useChannelStoreHook } from "@/store/modules/channel";
import { useUserStore } from "@/store/modules/user";

export const useHotelOrderListStore = defineStore({
  id: "y-hotel-order-list",
  state: () => ({
    loading: true,
    list: [],
    total: 0,
    booker: "",
    status: "all",
    pageNumber: 1,
    itisSort: "RECENT_BOOKING"
  }),
  actions: {
    init() {
      if (!this.list.length) {
        this.getOrders();
      }
    },
    setItisSort(sort) {
      this.itisSort = sort;
    },
    async getOrders() {
      const language = useUserStore().language;
      const channelStore = useChannelStoreHook();
      const yChannelStore = useYChannelStoreHook();
      const query = {
        preferred: {
          language: language || "zh",
          version: "v2"
        },
        filter: {
          _criteria: {
            channelRef: channelStore.channel?._id,
            type: "tpHotel"
          }
        },
        paging: {
          skip: 10 * (this.pageNumber - 1),
          limit: 10
        },
        _sort: {
          createdAt: -1
        }
      };
      query.sort = this.itisSort;
      if (this.status !== "all") {
        if (yChannelStore.configs?.pages?.defaultOrderTab) {
          query.category = this.status;
          query.filter = {
            type: ""
          };
        } else {
          query.filter.status = this.status;
        }
      }
      if (this.booker) {
        query.filter._criteria.userRef = this.booker;
      }
      this.loading = true;
      this.list = [];
      const res = await getHotelOrders(query);
      this.loading = false;

      this.list = _.get(res, "orders", []);
      this.total = _.get(res, "paging.count", 0);
    }
  }
});

export function useHotelOrderListStoreHook() {
  return useHotelOrderListStore(store);
}
